import { createAction, handleActions } from 'redux-actions';
import { takeLatest } from 'redux-saga/effects';
import * as hairlossProgressAPI from '../lib/api/hairlossProgress';
import createRequestSaga, {
  createRequestActionTypes,
} from '../lib/createRequestSaga';
import { hairlossProgressRecentData } from '../containers/hairlossProgress/dummyData';

// 탈모 진행률 Reducer
// Action Type 정의
const GET_HAIRLOSS_PROGRESS_RECENT_DUMMY =
  'hairlossProgress/GET_HAIRLOSS_PROGRESS_RECENT_DUMMY';

const [
  GET_HAIRLOSS_PROGRESS_RECENT,
  GET_HAIRLOSS_PROGRESS_RECENT_SUCCESS,
  GET_HAIRLOSS_PROGRESS_RECENT_FAILURE,
] = createRequestActionTypes('hairlossProgress/GET_HAIRLOSS_PROGRESS_RECENT');

// Action 생성
export const getHairlossProgressRecent = createAction(
  GET_HAIRLOSS_PROGRESS_RECENT,
  ({ user_id }) => ({ user_id }),
);
// 탈모진행률 dummy data
export const getDummyHairlossProgressRecent = createAction(
  GET_HAIRLOSS_PROGRESS_RECENT_DUMMY,
);

// saga 생성
export const getHairlossProgressRecentSaga = createRequestSaga(
  GET_HAIRLOSS_PROGRESS_RECENT,
  hairlossProgressAPI.getHairlossProgressRecent,
);
export function* hairlossProgressSaga() {
  yield takeLatest(GET_HAIRLOSS_PROGRESS_RECENT, getHairlossProgressRecentSaga);
}

const initialState = {
  hairlossProgressRecentData: null,
  hairlossProgressRecentDone: false,
  hairlossProgressRecentError: false,
};

export default handleActions(
  {
    // 단일 두피 분석 정보 불러오기 성공
    [GET_HAIRLOSS_PROGRESS_RECENT_SUCCESS]: (state, { payload: result }) => ({
      ...state,
      hairlossProgressRecentData: result.recent,
      hairlossProgressRecentDone: true,
      hairlossProgressRecentError: false,
    }),

    [GET_HAIRLOSS_PROGRESS_RECENT_DUMMY]: (state) => ({
      ...state,
      hairlossProgressRecentData: hairlossProgressRecentData,
    }),
    // 단일 두피 분석 정보 불러오기 실패
    [GET_HAIRLOSS_PROGRESS_RECENT_FAILURE]: (state, { payload: error }) => ({
      ...state,
      hairlossProgressRecentDone: false,
      hairlossProgressRecentError: error,
    }),
  },
  initialState,
);
